/**
 * Centralized access to Vite environment variables.
 *
 * Wrapping `import.meta.env` here lets jest mock it without needing ESM
 * support in the test runner.
 */

function withTrailingSlash(url: string | undefined): string | undefined {
  if (!url) return url;
  return url.endsWith("/") ? url : `${url}/`;
}

export const env = {
  firebaseConfigName: import.meta.env.VITE_FIREBASE_CONFIG_NAME,
  skedLinkBackendApiUrl: import.meta.env.VITE_SKED_LINK_BACKEND_API_URL,
  schedugramServerBackendUrl: withTrailingSlash(
    import.meta.env.VITE_SCHEDUGRAM_SERVER_BACKEND_URL
  ),
  skedLinkPublicDomain: import.meta.env.VITE_SKED_LINK_PUBLIC_DOMAIN,
} as const;
